/**
 * @generated SignedSource<<dcbe3f2ca2df2223fdb70abe01479a3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastAdminPopoverSectionDashboard_Dashboard$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "StorecastAdminPopoverSectionDashboard_Dashboard";
};
export type StorecastAdminPopoverSectionDashboard_Dashboard$key = {
  readonly " $data"?: StorecastAdminPopoverSectionDashboard_Dashboard$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastAdminPopoverSectionDashboard_Dashboard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastAdminPopoverSectionDashboard_Dashboard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "53c44c6516e3421ef3ab3c984e4c5403";

export default node;
